export const defaultSorters = [{ id: 'titleSearchSortFull', desc: false }];
